module.exports = __webpack_public_path__ + "assets/Rho.b806061761fca6880d26c5bd32552fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Rho.png
// module id = 797
// module chunks = 0